export default __webpack_public_path__ + "static/info_traffic_block_picto-d67c2a0d97d1e9b4bcfa2fe2d8cde92f.svg";